import React from "react";
import {
  Facebook,
  Instagram,
  MailOutline,
  Phone,
  Pinterest,
  Room,
} from "@material-ui/icons";
import styled from "styled-components";
import { mobile } from "../responsive";

const Container = styled.div`
  display: flex;
  ${mobile({ flexDirection: "column" })}
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Logo = styled.h1``;

const Desc = styled.p`
  margin: 20px 0px;
`;

const SocialContainer = styled.div`
  display: flex;
`;

const SocialIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  background-color: #${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
`;

const Center = styled.div`
  flex: 1;
  padding: 20px;
  ${mobile({ display: "none" })}
`;

const Title = styled.h3`
  margin-bottom: 30px;
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
`;

const ListItem = styled.li`
  width: 50%;
  margin-bottom: 10px;
`;

const Right = styled.div`
  flex: 1;
  padding: 20px;
  ${mobile({ backgroundColor: "#fff8f8" })}

`;

const ContactItem = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  
`;

const Payment = styled.img`
    width: 50%;
`;


const Footer = () => {
  return (
    <>
    <Container>
      <Left>
        <Logo>SamKo.</Logo>
        <Desc>
         前端網站工程師/顧問，開發軟體為react,redux，
         後端api將為node.js協助架設，搭配業界設計stock.adobe
         ,canva做頁面優化，SEO搜尋字也能後台管理方便你處理客戶第一手資訊
         且不再害怕網路電商！
        </Desc>
        <SocialContainer>
          <SocialIcon color="3B5999">
            <Facebook />
          </SocialIcon>
          <SocialIcon color="E4405F">
            <Instagram />
          </SocialIcon>
          <SocialIcon color='00BB00'>
          <i class="fab fa-line" style={{fontSize:'24px'}}></i>
          </SocialIcon>
          <SocialIcon color="E60023">
            <Pinterest />
          </SocialIcon>
        </SocialContainer>
      </Left>
      <Center>
        <Title>客製化功能</Title>
        <List>
          <ListItem>首頁</ListItem>
          <ListItem>購物車</ListItem>
          <ListItem>男士商品</ListItem>
          <ListItem>女士服飾</ListItem>
          <ListItem>服飾配件</ListItem>
          <ListItem>我的帳戶</ListItem>
          <ListItem>購買追蹤</ListItem>
          <ListItem>願望清單</ListItem>
          
          <ListItem>關鍵字</ListItem>
        </List>
      </Center>
      <Right>
        <Title>聯絡我們</Title>
        <ContactItem>
          
        <i class="fab fa-line" style={{marginRight:"10px",fontSize:'24px'}}></i><h4>@sam56325 </h4>
        </ContactItem>
        <ContactItem>
          <Phone style={{marginRight:"10px"}}/> 0939-738-669
        </ContactItem>
        <ContactItem>
          <MailOutline style={{marginRight:"10px"}} /> samko@gmail.com
        </ContactItem>
        <Payment src="https://i.ibb.co/Qfvn4z6/payment.png" />
      </Right>
    </Container>
    </>
  );
};

export default Footer;
